<script>
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import moment from "moment";
import store from "@/state/store";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [apibtoast, apigeneric],
  props: ["ihaleturu", "Dosyamenu", "DosyaId", "AktifMenu", "TutarGuncelle"],

  data() {
    return {
      FormData: {},
      TableData: {},
      Dosya: {},
      Malzeme: {},
      Satdosya: {},
      SumBedel: null,
      Tamamlandi: false,
      MenuDisable: false,
      PiyasaFiyatDisable: false,
      OnayBelgesiDisable: false,
      TeklifFiyatDisable: false,
      MuayeneKomisyonuDisable: false,
      IhaleUsuluKod: null,
      Alimturukod: null,
      FiyatSayisi: 0,
      Butcedisi: false,
      StrBirimHarcamaLimitTutari: {},
      LimitAsimi: false,
      IlanSonTarihGecmedi: false,
      malzemeKazananFirma: {},
      GetBirimButceTutari: null,
      clpsartnmame_komisyonu: "-",
      clpsozlesme_tasarisi: "-",
      clpsozlesme: "-",
      clpteklifSurecleri: "-",
      clpkarar: "-",
      ihale_turu: 0,
      acik_ihale: ["ec473142-264c-4a7b-9021-1cee655bec2a"],
      dogrudan_temin: ["38444b70-a0bc-4563-b192-075be993942b", "c62d0232-2af2-4162-bf0e-5dc894a7e264",
        "862edc3a-2c80-4e9d-b646-85e4b846b04f", "db3181bb-ce42-40b6-8d3a-edf5ba8554bc", "72d17596-2229-4f3b-9f25-98e1a784c567",
        "9d8b0440-4f7e-476b-87fa-62ece6908d60", "422eadfa-a2d2-4e0f-ad09-906da6c1340b", "0499c9c2-7bfd-490c-a7eb-600cbad51145",
        "619c9125-74c7-4089-aa86-8f083a6871f2", "1d4a1ee4-c8d3-4b19-98cc-fa8b66d2fa3d", "9ef2f8a0-5a8d-43fd-951d-e2a9393d3dba"],
      pazarlik_usulu: ["f6c00595-b47b-479d-bb4e-c9520999ab83", "4372aa54-d471-45a4-b9e0-36f8440a90a3",
        "6dff6d57-306e-4e6e-802f-506f956bed9e", "ceb79402-b8bc-4e2f-962b-46f150c80628", "296a5c06-386d-4b3b-97ed-f5190f7a3074",
        "b0c9d5d1-af46-4b4b-8bba-93355a8e86a2"],
      belli_istekler: ["0e614795-9f57-4621-8f19-5c3295884ff1"],
      istisna_kapsaminda: ["8f83d7de-ffba-45d1-b888-716b599a315b"],
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
    };
  },
  components: {},
  created() {
    this.KullaniciBilgileri = store.getters.["auth/UserRolles"];
    this.Get();
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get()
    },
    ihaleturu() {
      this.ihale_kontrol();
    },
    AktifMenu() {
      this.AktifMenu = this.AktifMenu.slice(0, 1);
    },
    Dosyamenu() {
      this.MenuAsamali();

    },
    TutarGuncelle() {
      this.Get()
    }

  },
  methods: {
    yetki_kontrol(yetki) {
      var sonuc = this.KullaniciBilgileri.indexOf(yetki);
      return sonuc;

    },
    loadOptions({ action, callback }) {
      this.options = [];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

          this.options = this.user;

          callback(null, this.options)
        })
      }
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("satdosya", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("satdosya");
            }
          });
        } else {
          this.Update("satdosya", this.FormData).then((res) => {
            if (res) {
              this.$emit("TableUpdate");
              this.$bvModal.hide("satdosya");
            }
          });
        }
      }
    },
    Get() {

      this.AktifMenu = this.AktifMenu.slice(0, 1);

      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.DosyaId,
      }).then((res) => {
        this.Dosya = res.Data;
        this.Butcedisi = res.Data.Butcedisi;

        const originalDate = new Date();

        if (res.Data.Yaklasikmaliyetwebsitesontarih != null && res.Data.Yaklasikmaliyetwebsite != false) {
   
          if (this.$options.filters.formatDate(originalDate) <= this.$options.filters.formatDate(res.Data.Yaklasikmaliyetwebsitesontarih)){

            this.IlanSonTarihGecmedi = true   //geçmedi
           
   
          } else {
            this.IlanSonTarihGecmedi = false  //geçti
          }


        }


        this.Satdosya = res.Data;
        if (res && Object.keys(res.Data).length > 0) {
          this.ActionsSingleGet({
            Service: "okeyvalues",
            Id: this.ihaleturu,
          }).then((res) => {
            this.IhaleUsuluKod = res.Data.Kod



          });


          this.ActionsFilterGet({
            Service: "StrBirimKontrolTutarlari/GetBirimButce",
            Page: this.Page,
            Filter: "&Donem=" + moment(String(res.Data.Dosyaacilistarih)).format("YYYY")
              + "&Birimid=" + res.Data.Ihaleyiyapanmakam
          }).then((GetBirimButce) => {
            if (GetBirimButce) {
              this.ActionsSabitGet(1548).then(keyvalues => {
                this.Alimturukod = 0
                for (var j = 0; j < keyvalues.Data.length; j++) {
                  if (keyvalues.Data[j].Id == res.Data.Alimturu) {
                    this.Alimturukod = keyvalues.Data[j].Kod
                  }
                }
                this.GetBirimButceTutari = 0
                for (let i = 0; i < Object.keys(GetBirimButce.Data).length; i++) {
                  if (this.Alimturukod == 1) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].tmal -
                      GetBirimButce.Data[i].thmal22d -
                      GetBirimButce.Data[i].thmal21f
                    ).toFixed(2)
                  }

                  if (this.Alimturukod == 2) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].thizmet -
                      GetBirimButce.Data[i].thhizmet22d -
                      GetBirimButce.Data[i].thhizmet21f
                    ).toFixed(2)
                  }
                  if (this.Alimturukod == 3) {
                    this.GetBirimButceTutari = (
                      GetBirimButce.Data[i].tyapim -
                      GetBirimButce.Data[i].thyapim22d -
                      GetBirimButce.Data[i].thyapim21f
                    ).toFixed(2)
                  }

                }

              });

            }
          });

        }

      });
      this.ActionsFilterGet({
        Service: "satdosyafirmafiyat/getgiris",
        Page: this.Page,
        Filter:
          "&Dosyaid=" +
          this.DosyaId +
          "&Asc=Sirano&Fiyatturu=1",
      }).then((res) => {
        this.TableData = res.Data
        this.Malzeme = this.groupBy(res.Data, "Dosyamalzemeid");
        this.FiyatSayisi = Object.keys(this.groupBy(res.Data, "Dosyafirmaid")).length
     //   this.BirimLimitleri();
      });


    },
    DosyaTamamlandi() {
      if (this.Dosya.Tamamlandi == false) {
        if (this.Dosyamenu['4100'] == true) {
          this.Dosya.Tamamlandi = true;
          this.Update("satdosya", this.Dosya)
        } else {
          this.Dosya.Tamamlandi = false;
          this.Update("satdosya", this.Dosya)
          this.$toast.error('Dosyayı Tamamlamak İçin Gerekli Aşamaları Tamamlayınız!');
        }
      } else {
        this.Dosya.Tamamlandi = false;
        this.Update("satdosya", this.Dosya)
      }

    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    ToplamMaliyetBedeliTotal() {

      var Total = 0;
      let Malzemeler = this.Malzeme;
      for (let Malzeme in Malzemeler) {

        var FiyatOrtalama = 0;
        var FiyatOlmayan = 0;
        for (let j = 0; j < Malzemeler[Malzeme].length; j++) {
          FiyatOrtalama += Malzemeler[Malzeme][j].Birimfiyat;
          if (Malzemeler[Malzeme][j].Birimfiyat == null) FiyatOlmayan += 1
        }
        FiyatOrtalama = FiyatOrtalama / (this.FiyatSayisi - FiyatOlmayan);
        FiyatOrtalama = FiyatOrtalama.toFixed(2)

        Total += FiyatOrtalama * Malzemeler[Malzeme][0].Adet;


      }


      return Total.toFixed(2);
    },
    BirimLimitleri() {
      console.log(this.Satdosya)
      this.ActionsFilterGet({
        Service: "StrBirimButceHarcamalari",
        Page: this.Page,
        Filter: "&Satdosyaid=" + this.DosyaId
      }).then((response) => {
        this.ActionsFilterGet({
        Service: "satdosya/GetUygunGorulenFirmalar",
        Page: this.Page,
        Filter: "&Desc=Sirano&Dosyaid=" + this.Satdosya.Id + "&YaklasikMaaliyetMi=true"
      }).then((Tutar) => {
        var MinTutar = 0
        if(this.Satdosya.Teklifdegerlendirmeyontem == 1 && Tutar.Succeeded == true){
          MinTutar += Tutar.Data[0].TotalMinFiyat2
        }
        if(this.Satdosya.Teklifdegerlendirmeyontem == 2 && Tutar.Succeeded == true){
          MinTutar += Tutar.Data[0].TotalMinFiyat
        }
        let filter = "&Birimbutceharcamalariid=" + response.Data[0].Id + "&Hesapkodlariid=" + this.Satdosya.Hesapkodu + "&Tutar=" + MinTutar ;
        
        if(this.Satdosya.Hesapkodu2 != null && this.Satdosya.Hesapkodu2 != "")
        {
          filter += "&Hesapkodlariid2=" + this.Satdosya.Hesapkodu2
        }
        this.ActionsFilterGet({
          Service: "StrBirimButceHarcamalariTutarlari/StrBirimButceHarcamalariTutarlariLimitControl",
          Page: this.Page,
          Filter: filter
        }).then((resp) => {
          this.StrBirimHarcamaLimitTutari = resp.Data;
          this.$emit("StrBirimHarcamaLimitTutari",resp.Data);
          if (this.StrBirimHarcamaLimitTutari.YuzdeOnLimit != null || this.StrBirimHarcamaLimitTutari.UstLimit != null) {
            if (this.Butcedisi != true) {
              this.LimitAsimi = true;
              this.$emit("TutarGuncelle2", 0);
            }
          }
          if (this.StrBirimHarcamaLimitTutari.YuzdeOnLimit == null && this.StrBirimHarcamaLimitTutari.UstLimit == null) {
            this.LimitAsimi = false;
          }
        });
      });
      });

    },
    MenuAsamali() {
  /*    if (this.Dosyamenu['1100'] == true && this.Dosyamenu['1200'] == false && this.Dosyamenu['1300'] == false && this.Dosyamenu['2100'] == false) {
        this.PiyasaFiyatDisable = false;
        this.OnayBelgesiDisable = true;
        this.TeklifFiyatDisable = true;
        this.MuayeneKomisyonuDisable = true;
      }
      if (this.Dosyamenu['1100'] == false && this.Dosyamenu['1200'] == false && this.Dosyamenu['1300'] == false && this.Dosyamenu['2100'] == false) {
        this.PiyasaFiyatDisable = true;
        this.OnayBelgesiDisable = true;
        this.TeklifFiyatDisable = true;
        this.MuayeneKomisyonuDisable = true;
      }
      if (this.Dosyamenu['1100'] == true && this.Dosyamenu['1200'] == true && this.Dosyamenu['1300'] == false && this.Dosyamenu['2100'] == false) {
        this.PiyasaFiyatDisable = true;
        this.OnayBelgesiDisable = false;
        this.TeklifFiyatDisable = true;
        this.MuayeneKomisyonuDisable = true;
      }
      if (this.Dosyamenu['1100'] == true && this.Dosyamenu['1200'] == true && this.Dosyamenu['1300'] == true && this.Dosyamenu['2100'] == false) {
        this.PiyasaFiyatDisable = true;
        this.OnayBelgesiDisable = true;
        this.TeklifFiyatDisable = false;
        this.MuayeneKomisyonuDisable = true;
      }
      if (this.Dosyamenu['1100'] == true && this.Dosyamenu['1200'] == true && this.Dosyamenu['1300'] == true && this.Dosyamenu['2100'] == true) {
        this.PiyasaFiyatDisable = true;
        this.OnayBelgesiDisable = true;
        this.TeklifFiyatDisable = true;
        this.MuayeneKomisyonuDisable = false;
      } */
    },
    ihale_kontrol() {
      var varmi = this.dogrudan_temin.indexOf(this.ihaleturu);
      if (varmi >= 0) {
        this.ihale_turu = 1;
      }

      varmi = this.acik_ihale.indexOf(this.ihaleturu);
      if (varmi >= 0) {
        this.ihale_turu = 2;
      }

      varmi = this.pazarlik_usulu.indexOf(this.ihaleturu);
      if (varmi >= 0) {
        this.ihale_turu = 3;
      }

      varmi = this.belli_istekler.indexOf(this.ihaleturu);
      if (varmi >= 0) {
        this.ihale_turu = 4;
      }

      varmi = this.istisna_kapsaminda.indexOf(this.ihaleturu);
      if (varmi >= 0) {
        this.ihale_turu = 5;
      }
    },

    menu_kontrol(menu) {
      if (menu == "sartnmame_komisyonu") {
        if (this.clpsartnmame_komisyonu == "+") {
          this.clpsartnmame_komisyonu = "-";
        } else {
          this.clpsartnmame_komisyonu = "+";
        }
      }
      if (menu == "sozlesme_tasarisi") {
        if (this.clpsozlesme_tasarisi == "+") {
          this.clpsozlesme_tasarisi = "-";
        } else {
          this.clpsozlesme_tasarisi = "+";
        }
      }
      if (menu == "sozlesme") {
        if (this.clpsozlesme == "+") {
          this.clpsozlesme = "-";
        } else {
          this.clpsozlesme = "+";
        }
      }

      if (menu == "teklifSurecleri") {
        if (this.clpteklifSurecleri == "+") {
          this.clpteklifSurecleri = "-";
        } else {
          this.clpteklifSurecleri = "+";
        }
      }

      if (menu == "karar") {
        if (this.clpkarar == "+") {
          this.clpkarar = "-";
        } else {
          this.clpkarar = "+";
        }
      }
    },
    MenuAlert(Data) {
    console.log(Data)
    /*  if (Data == 1300) {
        if (this.StrBirimHarcamaLimitTutari) {
          if (this.StrBirimHarcamaLimitTutari.YuzdeOnLimit != null) {
            if (this.Butcedisi != true) {
              this.$toast.error("Yüzde On Limit Kontrolleri Tekrar Yapılmalı");
            }
          }
          if (this.StrBirimHarcamaLimitTutari.UstLimit != null) {
            if (this.Butcedisi != true) {
              this.$toast.error("Üst Limit Kontrolleri Tekrar Yapılmalı");
            }
          }
        }else {
            this.$toast.error("YM/Piyasa Fiyat Araştırması Adımını Tamamlayınız");
          }
        if (this.IlanSonTarihGecmedi) {
            this.$toast.error("İhale Hala Yayında!");
          } else {
            this.$toast.error("YM/Piyasa Fiyat Araştırması Adımını Tamamlayınız");
          }
      }
      if (Data == 2100) {
        this.$toast.error("Onay Belgesi Adımını Tamamlayınız");
      }
      if (Data == 4100) {
        this.$toast.error("Teklif Fiyat Değerlendirme Adımını Tamamlayınız");
      }*/
    },
    DosyaMenuUpdate() {


    /*  if (this.Dosyamenu['1200'] == true) {

        if (this.StrBirimHarcamaLimitTutari.YuzdeOnLimit != null || this.StrBirimHarcamaLimitTutari.UstLimit != null) {
          if (this.Butcedisi != true) {
            this.Dosyamenu['1200'] = false;
            this.Dosyamenu['1300'] = false;
            this.$toast.error("Limit Kontrolleri Tekrar Yapılmalı");
            this.MenuAsamali()
          } else {
            this.MenuAsamali()
          }
        }
        if (this.IlanSonTarihGecmedi) {
          this.Dosyamenu['1200'] = false;
          this.Dosyamenu['1300'] = false;

          this.MenuAsamali()
        } else {
          this.MenuAsamali()
        }
        this.MenuAsamali()
      }
      else {
        this.MenuAsamali()
      } */
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.ActionsSingleGet({ Service: "SatDosya", Id: this.DosyaId }).then((res) => {
        let FormData = res.Data
        console.log(res.Data)
        FormData.Dosyamenu = JSON.stringify(this.Dosyamenu)
        if (this.AktifMenu == 3200) {
          this.ActionsFilterGet({ Service: "SatDosyaIhaleKomisyonu", Page: Page, Filter: "&Dosyaid=" + this.DosyaId + "&Asc=Sira" }).then((res) => {
            var bolen = 2;
            var kalan = res.Data.length % bolen;
            console.log(kalan);

            if (kalan == 0) {
              this.$toast.error("Komisyon üyeleri tek sayıdan oluşmalıdır.");
            } else {
              this.Update("satdosya", FormData).then();
            }
          });
        } else {
          this.Update("satdosya", FormData).then();
        }
        if (this.Dosyamenu['2100'] == true) {
          this.ActionsFilterGet({ "Service": "OPersonel/GetAllPersonel", "Page": this.Page, Filter: "&Id=" + FormData.Gerceklestirmegorevlisiid }).then((personel) => {
            this.ActionsFilterGet({ "Service": "SatDosya/GetUygunGorulenFirmalar", "Page": this.Page, Filter: "&Dosyaid=" + FormData.Id }).then((malzemeKazananFirma) => {
              this.malzemeKazananFirma = malzemeKazananFirma.Data;
              for (var Data in this.malzemeKazananFirma) {
                let MailData = {
                  Message: "Sayın İstekli; Üniversitemizce Doğrudan Temin Usulü ile alımı yapılan " + FormData.Dosyaadi + " Kalem Mal/Hizmet/Yapım işine vermiş olduğunuz teklif değerlendirilmiş olup " + this.malzemeKazananFirma[Data].Adet + "  " + this.malzemeKazananFirma[Data].Olcubirimi + "  " + this.malzemeKazananFirma[Data].Adi + " Mal/Hizmet/Yapım işi için en uygun teklifi verdiğiniz anlaşılmıştır. Malzeme teslimi ve diğer hususlarla ilgili 444 01 99 numaralı telefondan " + personel.Data[0].AdSoyad + " kişi ile irtibata geçmeniz gerekmektedir. Katılımınız için teşekkür eder, hayırlı işler dileriz.",
                  Recievermailadress: this.malzemeKazananFirma[Data].Email,
                  Subject: "Satın Alma Otomasyonu Bilgilendirme",
                };
                this.Post("TsvBildirimTanim/SendInvite", MailData).then((res) => {
                  if (res.data.Succeeded == true) {
                    console.log(res.data)
                  }
                });

              }
            });
          });
        } else {
          this.Update("satdosya", FormData).then();
        }

      });
    },

  },
};
</script>
<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title">{{ $t("satdosyamenu.Title") }}</h4>
      <div role="tablist">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">{{
                $t("satdosyamenu.HazirlikMenu.Title") }}</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" :visible="true">
            <b-card-body>
              <b-card-text>
                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__912" v-model="Dosyamenu['1100']"
                    @change="DosyaMenuUpdate"  />
                  <label class="form-check-label" for="__BVID__912" @click="$emit('aktif_menu', 1100)">
                    <a href="javascript: void(0);" class="text-dark">{{ $t("satdosyamenu.HazirlikMenu.Listehazirlama")
                    }}</a>
                  </label>
                </div>

                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__913" v-model="Dosyamenu['1200']"
                    @change="DosyaMenuUpdate(), Get()" />
                  <label class="form-check-label" for="__BVID__913" @click="$emit('aktif_menu', 1200)">
                    <a href="javascript: void(0);" class="text-dark">{{ $t("satdosyamenu.HazirlikMenu.YaklasikMaliyet")
                    }}</a>
                  </label>
                </div>

                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__914" v-model="Dosyamenu['1300']"
                    @change="DosyaMenuUpdate"
                    />
                  <label class="form-check-label" for="__BVID__914" @click="MenuAlert(1300)"
                    v-if="IlanSonTarihGecmedi == true || LimitAsimi == true || Dosyamenu['1200'] == false">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.DogrudanTeminMenu.OnayBelgesi")
                    }}</a>
                  </label>
                  <label class="form-check-label" for="__BVID__914" @click="$emit('aktif_menu', 1300)"
                    v-if="(IlanSonTarihGecmedi == false && Dosyamenu['1200'] == true && LimitAsimi == false)">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.DogrudanTeminMenu.OnayBelgesi")
                    }}</a>
                  </label>
                </div>

              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="ihale_turu == 1 || ihale_turu == 0" no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">{{
                $t("satdosyamenu.DogrudanTeminMenu.Title") }}</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" :visible="AktifMenu == 2 ? true : false">
            <b-card-body>
              <b-card-text>

                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__915" v-model="Dosyamenu['2100']"
                    @change="DosyaMenuUpdate"
                   />
                  <label class="form-check-label" for="__BVID__915" @click="MenuAlert(2100)"
                    v-if="IlanSonTarihGecmedi == true || LimitAsimi == true || Dosyamenu['1300'] == false">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.DogrudanTeminMenu.TeklifDegerlendirme") }}</a>
                  </label>
                  <label class="form-check-label" for="__BVID__915"
                    v-if="IlanSonTarihGecmedi == false && LimitAsimi == false && Dosyamenu['1300'] == true" @click="$emit('aktif_menu', 2100)">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.DogrudanTeminMenu.TeklifDegerlendirme") }}</a>
                  </label>
                </div>


              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="ihale_turu == 2" no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">{{
                $t("satdosyamenu.AcikIhaleMenu.Title") }}</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" :visible="true">
            <b-card-body>
              <b-card-text>
                <!--
                      <div id="altbasamak">
                        <div class="mb-2">
                            <label class="form-check-label" for="__BVID__912">  
                              <h5 class="text-truncate font-size-14 m-0">
                                <a
                        class="text-body fw-medium py-1 d-flex align-items-center"
                        data-toggle="collapse"
                        v-b-toggle="'sartnmame_komisyonu'"
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                        @click="menu_kontrol('sartnmame_komisyonu')"
                      >
                              <b>{{clpsartnmame_komisyonu}} {{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.Title')}}</b>
                                </a>
                                </h5>
                              </label>
                          </div>
                          <b-collapse
                          class="collapse show"
                          :id="'sartnmame_komisyonu'"
                        >
     
                     <div class="altbasamak">

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 7)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.GenelBilgiler')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 8)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.YeterlilikBelgesi')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 9)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.DegerlendirmeYontemi')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 10)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.Sureler')}}</a></h5>
                                </label>
                              </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 11)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.TeslimatSartlari')}}</a></h5>
                                  </label>
                                </div>
                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 12)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.idariSartnameKomisyonuMenu.EgitimGaranti')}}</a></h5>
                                  </label>
                                </div>

                              


                            </div> 
                          </b-collapse>

                        </div>
  -->
                <!--
                      <div id="altbasamak">
                        <div class="mb-2">
                            <label class="form-check-label" for="__BVID__912">  
                              <h5 class="text-truncate font-size-14 m-0">
                                <a
                        class="text-body fw-medium py-1 d-flex align-items-center"
                        data-toggle="collapse"
                        v-b-toggle="'sozlesme_tasarisi'"
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                        @click="menu_kontrol('sozlesme_tasarisi')"
                        >
                                <b> {{clpsozlesme_tasarisi}} {{$t('satdosyamenu.AcikIhaleMenu.SozlesmeTasarisi.Title')}}</b>
                          </a>      
                              
                                </h5>
                              
                              </label>
                          </div>

                        <b-collapse
                          class="collapse show"
                          :id="'sozlesme_tasarisi'"
                        >
                          <div class="altbasamak">

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 13)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.SozlesmeTasarisi.GenelTanimlar')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 14)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.SozlesmeTasarisi.SozlesmeMaddeleri')}}</a></h5>
                                </label>
                              </div>

                              <div class="mb-2 form-check">
                                <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 15)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.SozlesmeTasarisi.CezaveKesintiler')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 16)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.SozlesmeTasarisi.DigerHususlar')}}</a></h5>
                                  </label>
                                </div>

                          </div>

                          </b-collapse>

                        </div>

  -->
                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__916" v-model="Dosyamenu['3100']"
                    @change="DosyaMenuUpdate"  />
                  <label class="form-check-label" for="__BVID__916" @click="$emit('aktif_menu', 3100)">
                    <a href="javascript: void(0);" class="text-dark">{{ $t("satdosyamenu.AcikIhaleMenu.IlanBilgileri")
                    }}</a>
                  </label>
                </div>

                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__917" v-model="Dosyamenu['3200']"
                    @change="DosyaMenuUpdate"  />
                  <label class="form-check-label" for="__BVID__917" @click="$emit('aktif_menu', 3200)">
                    <a href="javascript: void(0);" class="text-dark">{{ $t("satdosyamenu.AcikIhaleMenu.IhaleKomisyonu")
                    }}</a>
                  </label>
                </div>




                <!--
                      <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                        <label @click="$emit('aktif_menu', 19)" class="form-check-label" for="__BVID__912">  
                          <h5 class="text-truncate font-size-14 m-0">
                          <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.IhaleTarihi')}}</a></h5>
                        </label>
                      </div>
                      <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                        <label @click="$emit('aktif_menu', 20)" class="form-check-label" for="__BVID__912">  
                          <h5 class="text-truncate font-size-14 m-0">
                          <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.DokumanSatilmasi')}}</a></h5>
                        </label>
                      </div>
                      <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                        <label @click="$emit('aktif_menu', 21)" class="form-check-label" for="__BVID__912">  
                          <h5 class="text-truncate font-size-14 m-0">
                          <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.Zeyilname')}}</a></h5>
                        </label>
                      </div>-->

                <div id="altbasamak">
                  <div class="mb-2">
                    <label class="form-check-label" for="__BVID__912">
                      <h5 class="text-truncate font-size-14 m-0">
                        <a class="
                              text-body
                              fw-medium
                              py-1
                              d-flex
                              align-items-center
                            " data-toggle="collapse" v-b-toggle="'teklifSurecleri'" role="button" aria-expanded="false"
                          aria-controls="categories-collapse" @click="menu_kontrol('teklifSurecleri')">
                          <b>
                            {{ clpteklifSurecleri }}
                            {{ $t("satdosyamenu.AcikIhaleMenu.teklifSurecleri.Title") }}</b>
                        </a>
                      </h5>
                    </label>
                  </div>

                  <b-collapse class="collapse show" visible :id="'teklifSurecleri'">
                    <div class="altbasamak">



                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__918" v-model="Dosyamenu['3310']"
                          @change="DosyaMenuUpdate"  />
                        <label class="form-check-label" for="__BVID__918" @click="$emit('aktif_menu', 3310)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.teklifSurecleri.ZarflarinKomisyonaTeslimi") }}</a>
                        </label>
                      </div>

                      <!--
                              <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 24)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.teklifSurecleri.ZarflarinKontrolu')}}</a></h5>
                                </label>
                              </div>-->

                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__919" v-model="Dosyamenu['3320']"
                          @change="DosyaMenuUpdate"  />
                        <label class="form-check-label" for="__BVID__919" @click="$emit('aktif_menu', 3320)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.teklifSurecleri.BelgeKontrolTutanagi1") }}</a>
                        </label>
                      </div>

                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__920" v-model="Dosyamenu['3330']"
                          @change="DosyaMenuUpdate"  />
                        <label class="form-check-label" for="__BVID__920" @click="$emit('aktif_menu', 3330)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.teklifSurecleri.TeklifEdilenFiyatlar") }}</a>
                        </label>
                      </div>





                      <!--
                              <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 27)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.teklifSurecleri.TutanaklarinVerilmesi')}}</a></h5>
                                </label>
                              </div>
                              <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                <label @click="$emit('aktif_menu', 28)" class="form-check-label" for="__BVID__912">  
                                  <h5 class="text-truncate font-size-14 m-0">
                                  <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.teklifSurecleri.BelgeKontrolTutanagi2')}}</a></h5>
                                  </label>
                                </div>-->
                    </div>
                  </b-collapse>
                </div>

                <div id="altbasamak">
                  <div class="mb-2">
                    <label class="form-check-label" for="__BVID__912">
                      <h5 class="text-truncate font-size-14 m-0">
                        <a class="
                                text-body
                                fw-medium
                                py-1
                                d-flex
                                align-items-center
                              " data-toggle="collapse" v-b-toggle="'karar'" role="button" aria-expanded="false"
                          aria-controls="categories-collapse" @click="menu_kontrol('karar')">
                          <b>{{ clpkarar }} {{ $t("satdosyamenu.AcikIhaleMenu.kararsurecleri.Title") }}</b>
                        </a>
                      </h5>
                    </label>
                  </div>
                  <b-collapse class="collapse show" visible :id="'karar'">
                    <div class="altbasamak">
                      <!--
                                  <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                    <label @click="$emit('aktif_menu', 29)" class="form-check-label" for="__BVID__912">  
                                      <h5 class="text-truncate font-size-14 m-0">
                                      <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.kararsurecleri.AraKarar')}}</a></h5>
                                    </label>
                                  </div>
                                <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 30)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.kararsurecleri.TeklifBedeliCetveli')}}</a></h5>
                                  </label>
                                </div> -->

                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__921" v-model="Dosyamenu['3410']"
                          @change="DosyaMenuUpdate"  />
                        <label class="form-check-label" for="__BVID__921" @click="$emit('aktif_menu', 3410)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.kararsurecleri.KomisyonKarari") }}</a>
                        </label>
                      </div>

                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__922" v-model="Dosyamenu['3420']"
                          @change="DosyaMenuUpdate" />
                        <label class="form-check-label" for="__BVID__922" @click="$emit('aktif_menu', 3420)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.kararsurecleri.KesinlesenKarar") }}</a>
                        </label>
                      </div>

                      <div class="form-check form-check-danger mb-2">
                        <input class="form-check-input" type="checkbox" id="__BVID__923" v-model="Dosyamenu['3430']"
                          @change="DosyaMenuUpdate"  />
                        <label class="form-check-label" for="__BVID__923" @click="$emit('aktif_menu', 3430)">
                          <a href="javascript: void(0);" class="text-dark">{{
                            $t("satdosyamenu.AcikIhaleMenu.kararsurecleri.SozlesmeyeDavet") }}</a>
                        </label>
                      </div>

                    </div>

                  </b-collapse>
                </div>

                <!--  <div id="altbasamak">
                      <div class="mb-2">
                        <label class="form-check-label" for="__BVID__912">
                          <h5 class="text-truncate font-size-14 m-0">
                            <a
                              class="
                                text-body
                                fw-medium
                                py-1
                                d-flex
                                align-items-center
                              "
                              data-toggle="collapse"
                              v-b-toggle="'sozlesme'"
                              role="button"
                              aria-expanded="false"
                              aria-controls="categories-collapse"
                              @click="menu_kontrol('sozlesme')"
                            >
                              <b
                                >{{ clpsozlesme }}
                                {{
                                  $t("satdosyamenu.AcikIhaleMenu.Sozlesme.Title")
                                }}</b
                              >
                            </a>
                          </h5>
                        </label>
                      </div>
                      <b-collapse class="collapse show"  visible :id="'sozlesme'">
                        <div class="altbasamak">
                          <div class="mb-2 form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              value="accepted"
                              id="__BVID__912"
                            />
                            <label
                              @click="$emit('aktif_menu', 34)"
                              class="form-check-label"
                              for="__BVID__912"
                            >
                              <h5 class="text-truncate font-size-14 m-0">
                                <a
                                  href="javascript: void(0);"
                                  class="text-dark"
                                  >{{
                                    $t(
                                      "satdosyamenu.AcikIhaleMenu.Sozlesme.SozlesmeBilgileri"
                                    )
                                  }}</a
                                >
                              </h5>
                            </label>
                          </div>
                      
                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 35)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.Sozlesme.AltYuklenici')}}</a></h5>
                                  </label>
                                </div>

                                <div class="mb-2 form-check">
                                  <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                                  <label @click="$emit('aktif_menu', 36)" class="form-check-label" for="__BVID__912">  
                                    <h5 class="text-truncate font-size-14 m-0">
                                    <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.AcikIhaleMenu.Sozlesme.AnahtarTeknikPersonel')}}</a></h5>
                                  </label>
                                </div>

                          <div class="mb-2 form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              value="accepted"
                              id="__BVID__912"
                            />
                            <label
                              @click="$emit('aktif_menu', 37)"
                              class="form-check-label"
                              for="__BVID__912"
                            >
                              <h5 class="text-truncate font-size-14 m-0">
                                <a
                                  href="javascript: void(0);"
                                  class="text-dark"
                                  >{{
                                    $t(
                                      "satdosyamenu.AcikIhaleMenu.Sozlesme.KesinTeminat"
                                    )
                                  }}</a
                                >
                              </h5>
                            </label>
                          </div>
                        </div>
                      </b-collapse>
                    </div> -->
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">{{
                $t("satdosyamenu.MuayeneKabulMenu.Title") }}</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>





                <div class="form-check form-check-danger mb-2">
                  <input class="form-check-input" type="checkbox" id="__BVID__923" v-model="Dosyamenu['4100']"
                    @change="DosyaMenuUpdate"
                     />
                  <label class="form-check-label" for="__BVID__923" @click="MenuAlert(4100)"
                    v-if="LimitAsimi == true || Dosyamenu['2100'] == false">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.MuayeneKabulMenu.KabulKomisyonu")
                    }}</a>
                  </label>
                  <label class="form-check-label" for="__BVID__923"
                    v-if="LimitAsimi == false && Dosyamenu['2100'] == true" @click="$emit('aktif_menu', 4100)">
                    <a :href="MenuDisable == true ? '' : 'javascript: void(0);'" class="text-dark">{{
                      $t("satdosyamenu.MuayeneKabulMenu.KabulKomisyonu")
                    }}</a>
                  </label>
                </div>



                <!--
                        <div class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 39)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.KontrolKomisyonu')}}</a></h5>
                          </label>
                        </div> 

                        <div    class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 40)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.KabulRaporu')}}</a></h5>
                          </label>
                        </div>

                        <div  v-if="ihale_turu == 2" class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 41)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.GeciciKabulTeklifBelgesi')}}</a></h5>
                          </label>
                        </div>
                        <div  v-if="ihale_turu == 2" class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 42)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.GeciciKabulTutanagi')}}</a></h5>
                          </label>
                        </div>

                        <div v-if="ihale_turu == 2" class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 43)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.KesinKabulTeklifBelgesi')}}</a></h5>
                          </label>
                        </div>
                        <div  v-if="ihale_turu == 2" class="mb-2 form-check"><input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912">
                          <label @click="$emit('aktif_menu', 44)" class="form-check-label" for="__BVID__912">  
                            <h5 class="text-truncate font-size-14 m-0">
                            <a href="javascript: void(0);" class="text-dark">{{$t('satdosyamenu.MuayeneKabulMenu.KesinKabulTutanagi')}}</a></h5>
                          </label>
                        </div>-->
              </b-card-text>
            </b-card-body>
          </b-collapse>
          <div class="ml-5 mb-2 form-check"
            v-if="((yetki_kontrol('SuperAdmin') >= 0 || yetki_kontrol('SatAdmin') >= 0) && this.Dosya.Tamamlandi == true) || (this.Dosya.Tamamlandi == false)">
            <input type="checkbox" class="form-check-input" value="accepted" id="__BVID__912"
              v-model="this.Dosya.Tamamlandi" @click="DosyaTamamlandi()">
            <label @click="DosyaTamamlandi()" class="form-check-label" for="__BVID__912">

              <h5 class="text-truncate font-size-14 m-0">
                <a href="javascript: void(0);" class="text-dark">Dosya Tamamlandı</a>
              </h5>
            </label>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<style scoped>
.altbasamak div {
  margin-left: 25px;
}

.card-header,
.card-header a {
  background-color: #323748;
  color: #fff !important;
}</style>